import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './card';
import { Skeleton } from './skeleton';

const ProgramSkeleton: React.FC = () => {
  return (
    <>
      {/* Program Details Card Skeleton */}
      <Card>
        <CardHeader className="flex flex-row justify-between items-start">
          <div className="w-full">
            <Skeleton className="h-6 w-3/4 mb-2" />
            <Skeleton className="h-4 w-1/4" />
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Client and Program Leader Info Skeleton */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Skeleton className="h-4 w-1/3 mb-2" />
              <Skeleton className="h-5 w-2/3" />
            </div>
            <div>
              <Skeleton className="h-4 w-1/3 mb-2" />
              <Skeleton className="h-5 w-2/3" />
            </div>
            <div>
              <Skeleton className="h-4 w-1/3 mb-2" />
              <Skeleton className="h-5 w-2/3" />
            </div>
          </div>

          {/* Dates Skeleton */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Skeleton className="h-4 w-1/3 mb-2" />
              <Skeleton className="h-5 w-2/3" />
            </div>
            <div>
              <Skeleton className="h-4 w-1/3 mb-2" />
              <Skeleton className="h-5 w-2/3" />
            </div>
          </div>

          {/* Survey Link Skeleton */}
          <div className="space-y-2">
            <Skeleton className="h-10 w-full" />
          </div>
        </CardContent>
      </Card>

      {/* Sessions Card Skeleton */}
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-1/4" />
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <Skeleton className="h-40 w-full" />
          </div>
        </CardContent>
      </Card>

      {/* Attendance Card Skeleton */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <Skeleton className="h-6 w-1/4" />
          <div className="space-x-2">
            <Skeleton className="h-9 w-24 inline-block" />
            <Skeleton className="h-9 w-24 inline-block" />
          </div>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-60 w-full" />
        </CardContent>
      </Card>
    </>
  );
};

export { ProgramSkeleton };